'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlFileDropOverlay', function () {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    template: "\n        <div class=\"tl-file-drop-overlay\" tl-on-file-drag=\"onFileDragConfig\">\n            <div class=\"overlay-content\">\n                <span>D\xE9posez les fichiers ici.</span>\n            </div>\n        </div>\n    ",
    link: function link($scope, $el, $attrs) {
      $scope.onFileDragConfig = {
        onEnter: function onEnter() {
          $el.addClass('drop-hover');
        },
        onLeave: function onLeave() {
          $el.removeClass('drop-hover');
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/drag-n-drop/tl-file-drop-overlay.js
// module id = 2932
// module chunks = 13